import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import List from "../../components/editableGrid/list/list";
import { columnConfig } from './columnConfig';
import t from '../../localization/en/translation.json';
import {  refresh } from "../../theme/icons";
import { MoreMenuOption } from '../../components/moreMenu/moreMenuOptions';
import MoreMenu from '../../components/moreMenu/moreMenu';
import { getAdminTypesRequest, updateAdminTypesRequest } from '../../store/actions/admin-general-actions';
import { updatefilterState } from '../../store/actions/list-actions';
import { lookupModel } from '../../containers/createProject/lookupModel';
import { getAdminConsoleAccess } from '../../utils/helper-utility';
import { ACTION_NAME, DEFAULT_SORT, ROW_MIN_HEIGHT, DESC_PER_ROW } from "./adminTypesConstants";
import AdminTypesModal from '../../components/adminTypesModal/adminTypesModal';
import { IAccessRight } from '../../models/user';
import { ISSPPlatformRole } from '../../models/IRoles';
import { IPagination, getDefaultPaginationModel, getPaginationModel } from '../../models/IPagination';
import './adminTypes.scss';

type IProps = RouteComponentProps<any> & {
  accessRight: IAccessRight;
  sspRoles: ISSPPlatformRole[];
  adminTypes: lookupModel[];
  getAdminTypesRequest: Function;
  updatefilterState: Function;
  paginationDetails: IPagination;
  updateAdminTypesRequest: Function;
  isTypeUpdated: boolean;
}

interface IState {
  paginationPayload: IPagination;
  isTypeModalOpen: boolean;
  selectedType: lookupModel | null;
  description: string
}

class AdminTypes extends Component<IProps, IState> {
  gridApi;
  state = {
    paginationPayload: getPaginationModel({
      ...getDefaultPaginationModel(),
      sortDirection: DEFAULT_SORT.sort,
      sortColumn: DEFAULT_SORT.colId,
      totalRecords: 0,
      filters: []
    }),
    isTypeModalOpen: false,
    selectedType: null,
    description: ""
  }

  componentDidMount() {
    this.getAdminTypes();
    this.updateFilterState();
  }

  componentDidUpdate(prevProps, prevState) {
    const { paginationPayload } = this.state;
    const { isTypeUpdated } = this.props;

    if (prevState.paginationPayload !== paginationPayload) {
      this.getAdminTypes();
      this.updateFilterState();
    }

    if(prevProps.isTypeUpdated !== isTypeUpdated && isTypeUpdated) {
      this.getAdminTypes();
    }
  }

  getAdminConsoleAccess = () => {
    const { accessRight, sspRoles } = this.props;
    const portalRole = (accessRight?.portalRoles && accessRight.portalRoles.length > 0 && accessRight.portalRoles[0]) || '';
    return getAdminConsoleAccess(portalRole, sspRoles);
  }

  getAdminTypes = () => {
    const { paginationPayload } = this.state;

    this.props.getAdminTypesRequest(paginationPayload);
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  handlePageNumberChange = (pageNumber) => {
    this.handlePagination({ pageNumber });
  }

  handlePageSizeChange = (pageSize) => {
    this.handlePagination({ pageSize, pageNumber: 1 });
  }

  handleRowHeight = ({ data }) => {
    if(!data.description || data.description.length <= DESC_PER_ROW) {
      return ROW_MIN_HEIGHT
    }

    return Math.ceil(data.description.length / DESC_PER_ROW) *  ROW_MIN_HEIGHT;
  }

  handleSorting = (sortColumn = DEFAULT_SORT.colId, sortDirection = DEFAULT_SORT.sort) => {
    const { paginationPayload } = this.state;

    if (paginationPayload.sortColumn === sortColumn &&
      paginationPayload.sortDirection === sortDirection) {
      return;
    }

    const updatedPaginationPayload = { ...paginationPayload, sortColumn, sortDirection }
    this.setState({ paginationPayload: updatedPaginationPayload })
  }

  handleFilterChange = (filters, sortColumn = DEFAULT_SORT.colId, sortDirection = DEFAULT_SORT.sort) => {
    const { paginationPayload } = this.state;
    const updatedPayload = { ...paginationPayload, filters, sortColumn, sortDirection, pageNumber: 1 };

    this.setState({ paginationPayload: updatedPayload })
  }

  updateFilterState = () => {
    const { filters = [], sortDirection, sortColumn } = this.state.paginationPayload;
    const isDefaultSort = sortDirection === DEFAULT_SORT.sort && sortColumn === DEFAULT_SORT.colId;
    const isClearAllDisabled = isDefaultSort && !filters.length

    this.props.updatefilterState({ filters, sortDirection, sortColumn, isClearAllDisabled })
  }

  handlePagination = (paginationParams) => {
    const { paginationPayload } = this.state;
    const updatedPaginationPayload = { ...paginationPayload, ...paginationParams };

    this.setState({ paginationPayload: updatedPaginationPayload, })
  }

  handleMoreMenuOptionClick = (actionName: string) => {
   if (actionName === ACTION_NAME.UPDATE) {
      const rows = this.gridApi.getSelectedRows();
      this.setState({ selectedType: rows[0], description: rows[0].description || "", isTypeModalOpen: true });
    }
  }  

  renderMoreMenu = () => {
    const options: MoreMenuOption[] = [
      { id: "123", title: t.update, icon: refresh, actionName: ACTION_NAME.UPDATE },
    ]

    return (
      <MoreMenu
        controlId="more-menu-apps"
        optionClickFn={this.handleMoreMenuOptionClick}
        options={options}
        vertical
        leftPlacement
      />
    )
  }

  renderDescriptionRows = ({ value }) => (<span>{value}</span>)

  handleUpdateTypes = (payload) => {
    const { updateAdminTypesRequest } = this.props;

    this.setState({ isTypeModalOpen: false });
    updateAdminTypesRequest([payload])
  }

  handleUpdateDescription = (description) => this.setState({ description })

  render() {
    const { adminTypes, paginationDetails  } = this.props;
    const { paginationPayload, isTypeModalOpen, selectedType, description } = this.state;
    const { portalAdminConsole } = this.getAdminConsoleAccess();
    const filteredColumns = portalAdminConsole ? columnConfig.filter(item => item.field !== "iconButton") : columnConfig;

    if (paginationDetails) {
      paginationPayload.totalRecords = paginationDetails.totalRecords;
      paginationPayload.totalRecordsWithoutFilter = paginationDetails.totalRecords || paginationPayload.totalRecordsWithoutFilter;
    }

    return (
      <div className={`admin-types ${portalAdminConsole ? "read-only" : ""}`}>
          <div className={`type-table`}>
            <List
              columnConfig={filteredColumns}
              defaultColDef={defaultColDef} 
              firstColumnBorderRight={true}
              rowData={adminTypes}
              paginate={true}
              frameworkComponents={{
                moreMenuCellRenderer: this.renderMoreMenu,
                typeDescriptionCellRender: this.renderDescriptionRows
              }}
              onGridReady={this.onGridReady}
              onSortChanged={this.handleSorting}
              currentPage={paginationPayload.pageNumber}
              pagination={paginationPayload}
              setItemsPerPage={this.handlePageSizeChange}
              onPageChange={this.handlePageNumberChange}
              onFilterChange={this.handleFilterChange}
              defaultSort={[DEFAULT_SORT]}
              getRowHeight={this.handleRowHeight}
            />
          </div>

        <AdminTypesModal
          isOpen={isTypeModalOpen}
          onClose={() => this.setState({ isTypeModalOpen: false })}
          onConfirm={this.handleUpdateTypes}
          selectedType={selectedType}
          onUpdateDescription={this.handleUpdateDescription}
          description={description}
        />
        </div>
    );
  }
}
const defaultColDef = {
  resizable: false,
  // Add other default properties that you want to apply to all columns
};

const mapStateToProps = ({ adminGeneralReducer, meta, meReducer }) => {
  return {
    adminTypes: adminGeneralReducer.adminTypes,
    paginationDetails: adminGeneralReducer.paginationDetails,
    isTypeUpdated: adminGeneralReducer.isTypeUpdated,
    accessRight: meReducer.accessRight,
    sspRoles: meta.userRoles
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAdminTypesRequest: payload => { dispatch(getAdminTypesRequest(payload)) },
    updatefilterState: payload => {dispatch(updatefilterState(payload))},
    updateAdminTypesRequest: payload => {dispatch(updateAdminTypesRequest(payload))}
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminTypes));
